import React, { useState, useEffect, useContext, useRef } from 'react';
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";
import DatePicker from 'react-datepicker';
import { datePopperConfig } from "../Shared/datePopperConfig.js";
import AddItemCustomFields from "../Shared/AddItemCustomFields.js";

let debounceTimer = null;

const AddItemPopup = ({ globalContext }) => {

    const [certificates, setCertificates] = useState([]);
    const [hasMoreCertificates, setHasMoreCertificates] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);
    const [isLoadingCertificates, setIsLoadingCertificates] = useState(false);
    const [alreadyAddedUniqueIds, setAlreadyAddedUniqueIds] = useState([]);
    const [isAddingUniqueIdsList, setIsAddingUniqueIdsList] = useState([]);

    const [addTitle, setAddTitle] = useState(globalContext.defaultSubmissionTitle ? globalContext.defaultSubmissionTitle : "");
    const [addDescription, setAddDescription] = useState("");
    const [addAssignedTo, setAddAssignedTo] = useState(globalContext.defaultSubmissionAssignedTo ? globalContext.defaultSubmissionAssignedTo : window.currentUserId);
    const [addStatus, setAddStatus] = useState(0);
    const [addPriority, setAddPriority] = useState(4);
    const [addType, setAddType] = useState(0);
    const [addStartDate, setAddStartDate] = useState("");
    const [addExpectedCompletionDate, setAddExpectedCompletionDate] = useState("");
    const [addFinishedDate, setAddFinishedDate] = useState("");
    const [certificateId, setCertificateId] = useState(globalContext.defaultSubmissionCertificateId ? globalContext.defaultSubmissionCertificateId : window.certificateId);
    const [selectedCertificateName, setSelectedCertificateName] = useState(globalContext.defaultSubmissionCertificateName ? globalContext.defaultSubmissionCertificateName : "");
    const [certificateSearch, setCertificateSearch] = useState("");


    const [errorAddTitle, setErrorAddTitle] = useState(false);
    const [errorAddDescription, setErrorAddDescription] = useState(false);
    const [errorAddStatus, setErrorAddStatus] = useState(false);
    const [errorAddPriority, setErrorAddPriority] = useState(false);
    const [errorAddType, setErrorAddType] = useState(false);
    const [errorAddStartDate, setErrorAddStartDate] = useState(false);
    const [errorAddExpectedCompletionDate, setErrorAddExpectedCompletionDate] = useState(false);
    const [errorAddFinishedDate, setErrorAddFinishedDate] = useState(false);

    
    const [priority, setPriority] = useState(4);
    const [isEditingFieldPriority, setIsEditingFieldPriority] = useState(false);
    const [isEditingFieldStatus, setIsEditingFieldStatus] = useState(false);
    const [isEditingFieldType, setIsEditingFieldType] = useState(false);
    const [isAddingSubmission, setIsAddingSubmission] = useState(false);
    const [errorMissingCertificate, setErrorMissingCertificate] = useState(false);
    

    



    const AppContext = globalContext;

    


    const doTextSearchTask = (textSearch) => {
        let debouncingTime = 500;
        clearTimeout(debounceTimer);

        debounceTimer = setTimeout(() => {
            loadSearchResults({ localSearch: textSearch, nextPage: false });
        }, debouncingTime);
    };


    // This method validates if the form field if filled, sets the error message to
    // true for that field and returns false meaning the field is not valid

    const validFormField = (field, errorFunc) => {
        if (field == "") {
            errorFunc(true);
            return false;
        }
        errorFunc(false);
        return true;
    };


    const loadSearchResults = ({
        localSearch = certificateSearch,
        nextPage = false,
    } = {}) => {

        if (isLoadingCertificates) return;

        setIsLoadingCertificates(true);

        let local_certificates = certificates;
        let local_certificates_page = currentPage;

        if (nextPage == false) {
            local_certificates = [];
            local_certificates_page = 1;
            setCertificates(local_certificates);
            setCurrentPage(local_certificates_page);
            setHasMoreCertificates(true);
        } else {
            local_certificates_page++;
            setCurrentPage(local_certificates_page);
        }


        let certificatesUrl = "/umbraco/api/ProductRegistrationsApi/CompanyCertificates";

        let loadCertificatesURL = certificatesUrl + `?` +
            `search=${encodeURIComponent(localSearch)}&` +
            `page=${encodeURIComponent(local_certificates_page)}&` +
            `sortBy=&` +
            `sortType=&`
            ;

        let requestOptions = {};

        fetch(loadCertificatesURL, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    setHasMoreCertificates(false);
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((result) => {

                // If no items returned it means there is no more certificates to retrieve
                if (result.length == 0)
                    setHasMoreCertificates(false);
                else {
                    // Was it a fetch more request? Then append to certificates.
                    if (nextPage) {
                        let res = [...local_certificates, ...result];
                        setCertificates(res);
                    } else {
                        setCertificates(result);
                    }

                }

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                setHasMoreCertificates(false);
            })
            .finally(() => {
                setIsLoadingCertificates(false);
            });


    };



    const addSubmission = () => {
        
        let newItem = {
            Id: 0,
            Title: addTitle,
            Description: addDescription,
            CertificateId: certificateId,
            Status: parseInt(addStatus),
            AssignedTo: parseInt(addAssignedTo),
            Priority: parseInt(addPriority),
            StartDate: addStartDate != "" ? addStartDate : null,
            ExpectedCompletionDate: addExpectedCompletionDate != "" ? addExpectedCompletionDate : null,
            FinishedDate: addFinishedDate != "" ? addFinishedDate : null,
            Type: parseInt(addType),
            CustomFieldsAnswers: AppContext.newItemCustomFieldsAnswers,
            ChangeAssessmentItemId: AppContext.ChangeAssessmentItemId ? AppContext.ChangeAssessmentItemId : null,
        };
        



        let isValidForm = true;


        setErrorAddTitle(false);
        setErrorAddDescription(false);
        setErrorAddStatus(false);
        setErrorAddPriority(false);
        setErrorAddType(false);
        setErrorAddStartDate(false);
        setErrorAddExpectedCompletionDate(false);
        setErrorAddFinishedDate(false);
        setErrorMissingCertificate(false);


        if (!validFormField(addTitle, setErrorAddTitle))
            isValidForm = false;
        if (!validFormField(addStartDate, setErrorAddStartDate))
            isValidForm = false;

        if (!certificateId) {
            setErrorMissingCertificate(true);
            isValidForm = false;
        }

        if (!isValidForm) return false;



        let dataUrl = AppContext.dataUrl;

        let requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(newItem)
        };


        setIsAddingSubmission(true);

        fetch(dataUrl, requestOptions)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 401)
                        document.dispatchEvent(new Event("api:unauthorized"));

                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then((item) => {

                let result = [item, ...AppContext.data];

                AppContext.setData(result);

                AppContext.showAddItemPopup(false);

                AppContext.refreshGraphs();

            })
            .catch((error) => {
                // Handle any errors that occurred during the fetch
                console.log("error: " + error);
            })
            .finally(() => {
                setAddStatus(1);
                setAddPriority(4);
                setAddType(0);
                setIsAddingSubmission(false);
            });


    }





    const useCertificate = (certificate) => {

        setSelectedCertificateName(certificate.Reference + " (" + certificate.Country.CountryName + ")");
        setCertificateId(certificate.CertificateId);
        setErrorMissingCertificate(false);

    }





    const targetRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting);
            },
            { threshold: 0 } // Adjust the threshold as needed
        );

        if (targetRef.current) {
            observer.observe(targetRef.current);
        }

        return () => {
            if (targetRef.current) {
                observer.unobserve(targetRef.current);
            }
        };
    }, [isLoadingCertificates]);


    useEffect(() => {

        if (isVisible && hasMoreCertificates && !isLoadingCertificates) {
            loadSearchResults({ nextPage: true });
        }
    }, [isVisible]);





    





    return (
        <div className="add-task-popup">
            <div style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ width: "50%" }}>
                    <h3>Add {AppContext.singleItemTitle}</h3>
                </div>
                <div style={{ width: "50%", textAlign: "right" }}>
                    <button
                        className="close-button"
                        onClick={() => AppContext.showAddItemPopup(false)}
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>
            </div>







            <input className={`form-field-text add-task-field-name ${errorAddTitle ? " form-field-error" : null}`}
                value={addTitle}
                onChange={(e) => setAddTitle(e.target.value)}
                style={{ width: "100%" }} type="text" placeholder="Title *" />

            {errorAddTitle && (
                <span className="form-field-error-message">
                    This field is necessary
                </span>
            )}

            <br /><br />

            <textarea className={`form-field-text add-task-field-name ${errorAddDescription ? " form-field-error" : null}`}
                value={addDescription}
                onChange={(e) => setAddDescription(e.target.value)}
                style={{ width: "100%" }} placeholder="Description" />
            <br /><br />



            {!window.certificateId && !globalContext.defaultSubmissionCertificateId ? 
                <div style={{ display: "flex", flexDirection: "column", marginBottom: "10px"}}>

                    <input className="form-field-text" type="text" placeholder="🔍 Search for the Submission Certificate *" value={certificateSearch} onChange={(e) => { setCertificateSearch(e.target.value); doTextSearchTask(e.target.value); }} />

                    <div className="datatable-header" style={{ marginTop: "20px" }}>
                        <div style={{ flex: 1 }}>CERTIFICATE NAME</div>
                        <div style={{ flex: 2 }}>COUNTRY </div>
                        <div style={{ width: `50px` }}>ACTION</div>
                    </div>

                    <div style={{ maxHeight: "180px", overflow: "auto", marginBottom: "15px" }}>

                        <div>

                            {certificates && certificates.map((row, index) => {

                                return (<>
                                    <div className="datatable-row" style={{display: "flex"}}>
                                        <div style={{ flex: 1 }}>{row.Reference}</div>
                                        <div style={{ flex: 2 }}><img className="countryFlag" src={row.Country.FlagLink} style={{ height: "21px", marginRight: "5px" }} />{row.Country.CountryName}</div>
                                        <div style={{ width: "90px" }}>
                                            <span
                                                style={{ borderRadius: "10px", backgroundColor: certificateId === row.CertificateId ? "#c0c0c0" : "#b4dcff", padding: "1px 9px", cursor: "pointer" }}
                                                onClick={() => { useCertificate(row); }}
                                            >
                                                {certificateId === row.CertificateId ? "Added" : "Add"}
                                            </span>
                                        </div>
                                    </div>

                                </>)
                            })}
                        </div>


                        {isLoadingCertificates ?
                            <div style={{ textAlign: "center" }}>
                                <LoadingSpinnerImage />
                            </div>
                            :
                            <>
                            {!hasMoreCertificates ?
                                <div className="no-more-results">No more items</div>
                                :
                                <>
                                    {/* If this div is visible it should try to load more files. Either inner div content or minHeight is mandatory for the intersector to work */}
                                    <div ref={targetRef} style={{ minHeight: "5px" }}></div>
                                </>
                            }
                            </>
                        }

                    </div>


                    {certificateId ? <p>
                        Certificate selected: <b>{selectedCertificateName}</b>
                    </p> : <div>
                            <p><span>Certificate selected:</span> None.</p>
                            <p> <b>Please choose the certificate of this submission.</b></p>
                        </div>
                    }


                    {errorMissingCertificate ? <span className="form-field-error-message">* The certificate is a mandatory field</span> : null }

                </div>
            : null}




            <div style={{display: "flex", flexDirection: "row"} }>

                <div style={{ width: "25%" }}>
                    Assign to
                    <br />
                    <select
                        value={addAssignedTo}
                        onChange={(e) => setAddAssignedTo(e.target.value)}
                    >
                        {AppContext.users.map((user, index) => (
                            <option key={index} value={user.Id}>
                                {user.Name}
                            </option>
                        ))}
                    </select>

                </div>






                <div style={{ width: "25%" }}>

                    Status:
                    <br />
                    {isEditingFieldStatus === false ? (
                        <>
                            <span
                                className="editable-field-span editable-field-span-complex"
                                onClick={(e) =>
                                    setIsEditingFieldStatus(true)
                                }
                            >
                                <AppContext.SubmissionStatus value={addStatus} />

                            </span>
                        </>
                    ) : (
                        <>
                            <span>
                                <select
                                    value={addStatus}
                                    onBlur={() =>
                                        setIsEditingFieldStatus(false)
                                    }
                                    onChange={(e) => {
                                        setAddStatus(e.target.value);
                                    }}
                                >
                                    {AppContext.submissionPossibleStatuses.map((status, index) => (
                                        <option key={index} value={status.id}>
                                            {status.name}
                                        </option>
                                    ))}
                                </select>
                            </span>
                        </>
                    )}


                </div>























                <div style={{ width: "25%" }}>

                    Priority:
                    <br />
                    {isEditingFieldPriority === false ? (
                        <>
                            <span
                                className="editable-field-span editable-field-span-complex"
                                onClick={(e) =>
                                    setIsEditingFieldPriority(true)
                                }
                            >
                                <AppContext.SubmissionPriority value={addPriority} />

                            </span>
                        </>
                    ) : (
                        <>
                            <span>
                                <select
                                    value={addPriority}
                                    onBlur={() =>
                                        setIsEditingFieldPriority(false)
                                    }
                                    onChange={(e) => {
                                        setAddPriority(e.target.value);
                                    }}
                                >
                                    {AppContext.submissionPriorities.map((priority, index) => (
                                        <option key={index} value={priority.id}>
                                            {priority.name}
                                        </option>
                                    ))}
                                </select>
                            </span>
                        </>
                    )}


                </div>







                <div style={{ width: "25%" }}>

                    Type:
                    <br />
                    {isEditingFieldType === false ? (
                        <>
                            <span
                                className="editable-field-span editable-field-span-complex"
                                onClick={(e) =>
                                    setIsEditingFieldType(true)
                                }
                            >
                                <AppContext.SubmissionType value={addType} />

                            </span>
                        </>
                    ) : (
                        <>
                            <span>
                                <select
                                    value={addType}
                                    onBlur={() =>
                                        setIsEditingFieldType(false)
                                    }
                                    onChange={(e) => {
                                        setAddType(e.target.value);
                                    }}
                                >
                                    {AppContext.submissionTypes.map((type, index) => (
                                        <option key={index} value={type.id}>
                                            {type.name}
                                        </option>
                                    ))}
                                </select>
                            </span>
                        </>
                    )}


                </div>



            </div>



            <br />
            <br />

            <div style={{ display: "flex", flexDirection: "row" }}>

                <div style={{ width: "25%" }}>
                    Start Date
                    <br />
                    <DatePicker
                        className={`datepicker-field add-task-field-date-start ${errorAddStartDate ? "form-field-error" : null
                            }`}
                        dateFormat="yyyy-MM-dd"
                        selected={addStartDate}
                        onChange={(date) => {
                            setAddStartDate(date);
                        }}
                        popperPlacement={datePopperConfig.placement}
                        popperModifiers={datePopperConfig.modifiers}
                    />
                    {errorAddStartDate && (
                        <div style={{ width: "100%" }}>
                            <span className="form-field-error-message">
                                This field is necessary
                            </span>
                        </div>
                    )}
                </div>

                <div style={{ width: "25%" }}>
                    Expected Completion Date
                    <br />
                    <DatePicker
                        className={`datepicker-field add-task-field-date-start ${errorAddExpectedCompletionDate ? "form-field-error" : null
                            }`}
                        dateFormat="yyyy-MM-dd"
                        selected={addExpectedCompletionDate}
                        onChange={(date) => {
                            setAddExpectedCompletionDate(date);
                        }}
                        popperPlacement={datePopperConfig.placement}
                        popperModifiers={datePopperConfig.modifiers}
                    />
                    {errorAddExpectedCompletionDate && (
                        <div style={{ width: "100%" }}>
                            <span className="form-field-error-message">
                                This field is necessary
                            </span>
                        </div>
                    )}
                </div>

                <div style={{ width: "25%" }}>
                    Finished Date
                    <br />
                    <DatePicker
                        className={`datepicker-field add-task-field-date-start ${errorAddFinishedDate ? "form-field-error" : null
                            }`}
                        dateFormat="yyyy-MM-dd"
                        selected={addFinishedDate}
                        onChange={(date) => {
                            setAddFinishedDate(date);
                        }}
                        popperPlacement={datePopperConfig.placement}
                        popperModifiers={datePopperConfig.modifiers}
                    />
                
                </div>

            </div>


            
                {/* CUSTOM FIELDS */}
            {AppContext.enableCustomFields ? 
                    <>
                        <br />
                        <AddItemCustomFields entityType={AppContext.entityTypeId} context={AppContext} />
                    </>
                : null}



            {/* BUTTONS */}

            <br />
            <div className="action-button-bar">

                <div className="action-button-bar-left">
                    <button
                        className="action-button cancel-button"
                        onClick={() => AppContext.showAddItemPopup(false)}
                    >
                        Close
                    </button>
                </div>
                <div className="action-button-bar-center">

                </div>

                <div className="action-button-bar-right">
                    {isAddingSubmission ? (
                        <LoadingSpinnerImage />
                    ) : (
                        <button
                            className="action-button save-button"
                            onClick={addSubmission}
                        >
                            Add Submission
                        </button>
                    )}
                </div>
            </div>



            <br />

        </div>
    );
};








export default AddItemPopup;